import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/clear-documents.jpeg";

function KlareDokumenterTryggereBomiljoer() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.clearDocuments.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.clearDocuments.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/klare-dokumenter-skaper-tryggere-bomiljoer"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.clearDocuments.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.clearDocuments.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.clearDocuments.date")}
          </p>
        </div>
        <div className="w-full md:w-3/5">
          <img
            src={article_img}
            className="w-full"
            alt={i18next.t("pages.articles.list.clearDocuments.imageAlt")}
          />
          <p className="text-sm text-secondary mt-2">
            {i18next.t("pages.articles.credit.photoBy")}{" "}
            <a
              href="https://nor01.safelinks.protection.outlook.com/?url=https%3A%2F%2Funsplash.com%2F%40annikaashley%3Futm_source%3Dunsplash%26utm_medium%3Dreferral%26utm_content%3DcreditCopyText&data=05%7C02%7Cj.ugland%40xperconsulting.no%7C64afeb5fc71d47b3fe8e08de3c8916f2%7C6051a23802de4cb0a8c56136b6c8c676%7C0%7C0%7C639014756828157696%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=S4ye3dufM5X2S32IMdQ2prZYdx1ofCIzpLFXKtl5R0c%3D&reserved=0"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Annika Ashley
            </a>{" "}
            {i18next.t("pages.articles.credit.on")}{" "}
            <a
              href="https://nor01.safelinks.protection.outlook.com/?url=https%3A%2F%2Funsplash.com%2Fphotos%2Fa-group-of-boats-floating-on-top-of-a-body-of-water-CP8_CR9R4Ko%3Futm_source%3Dunsplash%26utm_medium%3Dreferral%26utm_content%3DcreditCopyText&data=05%7C02%7Cj.ugland%40xperconsulting.no%7C64afeb5fc71d47b3fe8e08de3c8916f2%7C6051a23802de4cb0a8c56136b6c8c676%7C0%7C0%7C639014756828181681%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=T7oy7RtE4aYusUxtGz0WTXhaj5BNW2qU42H6z64xL5M%3D&reserved=0"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Unsplash
            </a>
          </p>
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p>{i18next.t("pages.articles.list.clearDocuments.sections.intro.content1")}</p>
            <p>{i18next.t("pages.articles.list.clearDocuments.sections.intro.content2")}</p>

            <p className="mt-6">
              {i18next.t("pages.articles.list.clearDocuments.sections.moreThanRegulations.content1")}
              <a href="/artikler/tilgjengelighetsdirektivet" className="underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.clearDocuments.sections.moreThanRegulations.link")}
              </a>
              {i18next.t("pages.articles.list.clearDocuments.sections.moreThanRegulations.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.whenNotReach.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.clearDocuments.sections.whenNotReach.content")}</p>
            <ul className="list-disc list-outside ml-10 my-4">
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.whenNotReach.points.1")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.whenNotReach.points.2")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.whenNotReach.points.3")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.whenNotReach.points.4")}</li>
            </ul>
            <p className="mt-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.whenNotReach.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.accessibleStrengthens.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.clearDocuments.sections.accessibleStrengthens.content")}</p>
            <ul className="list-disc list-outside ml-10 my-4">
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.accessibleStrengthens.points.1")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.accessibleStrengthens.points.2")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.accessibleStrengthens.points.3")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.accessibleStrengthens.points.4")}</li>
            </ul>
            <p className="mt-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.accessibleStrengthens.content2")}
            </p>
            <p>{i18next.t("pages.articles.list.clearDocuments.sections.accessibleStrengthens.content3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.industryOpportunity.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.industryOpportunity.content1")}
              <a href="/artikler/er-din-bedrift-klar" className="underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.clearDocuments.sections.industryOpportunity.link")}
              </a>
              {i18next.t("pages.articles.list.clearDocuments.sections.industryOpportunity.content2")}
            </p>
            <p className="mb-2">{i18next.t("pages.articles.list.clearDocuments.sections.industryOpportunity.content3")}</p>
            <ul className="list-disc list-outside ml-10 my-4">
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.industryOpportunity.points.1")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.industryOpportunity.points.2")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.industryOpportunity.points.3")}</li>
            </ul>
            <p className="mt-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.industryOpportunity.content4")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.xperEasy.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.xperEasy.content1")}
              <a href="/artikler/gjor-dokumentene-dine-tilgjengelige" className="underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.clearDocuments.sections.xperEasy.link")}
              </a>
              {i18next.t("pages.articles.list.clearDocuments.sections.xperEasy.content2")}
            </p>
            <ul className="list-disc list-outside ml-10 my-4">
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.xperEasy.points.1")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.xperEasy.points.2")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.xperEasy.points.3")}</li>
              <li>{i18next.t("pages.articles.list.clearDocuments.sections.xperEasy.points.4")}</li>
            </ul>
            <p className="mt-2">
              {i18next.t("pages.articles.list.clearDocuments.sections.xperEasy.content3")}
            </p>

            <p className="mt-6">
              {i18next.t("pages.articles.list.clearDocuments.sections.cta.content")}{" "}
              <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.clearDocuments.sections.cta.link")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KlareDokumenterTryggereBomiljoer;


